
export const omori_controls=(k)=>{

    const omori = k.get("omori")[0];
    omori.play("idle_down");
    let isMoving = false;

    const aubrey = k.get("aubrey")[0];
    aubrey.play("idle_down");


k.onKeyDown(["right", "d"], ()=>{
    omori.move(400,0);
    if(!isMoving){
        omori.play("walk_right")
        isMoving=true;
    }
});

k.onKeyRelease(["right", "d"], ()=>{
    omori.play("idle_right")
    isMoving = false;
})

k.onKeyDown(["left", "a"], ()=>{
    omori.move(-400,0);
    if(!isMoving){
        omori.play("walk_left");
        isMoving=true
    }
});

k.onKeyRelease(["left", "a"], ()=>{
    omori.play("idle_left");
    isMoving=false;
})

k.onKeyDown(["up", "w"], ()=>{
    omori.move(0,-400);
    if(!isMoving){
        omori.play("walk_up")
        isMoving = true
    }
});

k.onKeyRelease(["up", "w"], ()=>{
    omori.play("idle_up")
    isMoving = false;
})

k.onKeyDown(["down", "s"], ()=>{
    omori.move(0,400);
    if(!isMoving){
        omori.play("walk_down");
        isMoving = true;
    }
});

k.onKeyRelease(["down", "s"], ()=>{
    omori.play('idle_down');
     k.debug.log("Is moved")
    isMoving = false;
})

const isShape = omori.is("shape");
}
